export default __webpack_public_path__ + "static/media/ISSO CLASS-2_SYLLABUS_2025-26.68e9fada.pdf";